import React from 'react'
import LayoutMini from './LayoutMini';

// components
import AboutMe from '../about/AboutMe';
import Portfolio from '../portfolio/Portfolio';


const Home = () => {

  return (
    <LayoutMini>
      <section className="wabe_head">
        <AboutMe />
      </section>
      <section className="wabe">
        <Portfolio />
      </section>
    </LayoutMini>
  );
};

export default Home;